module.exports = __webpack_public_path__ + "static/staff-chris-89d266840e0152839cc2961b3934a51a.png";